@if (!productPrice().redacted) {
  @if (priceType() === 'price-discount') {
    <ui-product-prices-discount
      [price]="price()"
      [strikethroughPrice]="strikethroughPrice()"
      [showThousandthsPlace]="showThousandthsPlace()"
      [small]="small()"
    ></ui-product-prices-discount>
  } @else if (priceType() === 'price-best') {
    <ui-product-prices-best
      [small]="small()"
      [price]="price()"
      [showThousandthsPlace]="showThousandthsPlace()"
    ></ui-product-prices-best>
  } @else if (priceType() === 'price-advantage-free') {
    <ui-product-price-advantage-free
      [small]="small()"
    ></ui-product-price-advantage-free>
  } @else if (priceType() === 'price-advantage') {
    <ui-product-price-advantage
      [small]="small()"
    ></ui-product-price-advantage>
  } @else if (priceType() === 'price-reimbursement') {
    <ui-product-price-reimbursement
      [small]="small()"
      [price]="price()"
      [showThousandthsPlace]="false"
    ></ui-product-price-reimbursement>
  } @else {
    <ui-product-prices-default
      [price]="price()"
      [showThousandthsPlace]="showThousandthsPlace()"
    ></ui-product-prices-default>
  }
}
